import React from 'react';
import { LOADING_TEXT } from '@/utils/constants/constants';

const SpinnerComp = (props: any) => {
    return (
        <div className="d-flex justify-content-center w-100">
            <div className="spinner-border spinner-border m-5" role="status" style={props.style}>
                <span className="sr-only">{LOADING_TEXT}</span>
            </div>
        </div>
    );
}

export default SpinnerComp;
